<div class="expandable-wrapper">
    <mat-expansion-panel class="expandable"
                         [expanded]="expanded"
                         (opened)="expanded = true"
                         (closed)="expanded = false"
                         [disabled]="disabled"
                         [hideToggle]="disabled">
        <mat-expansion-panel-header>
            <mat-panel-title (click)="changeTitle($event)">
                <ion-text *ngIf="!inTitleEditMode">{{ panel.title }}</ion-text>
                <ion-input *ngIf="inTitleEditMode"
                           class="input--editable"
                           id="title"
                           type="text"
                           name="title"
                           aria-label="Input Value"
                           mode="ios"
                           inputmode="text"
                           [(ngModel)]="panel.title"
                           (ionChange)="onTitleChange($event)"
                           (ionBlur)="inTitleEditMode = false; onInputChange();"></ion-input>
            </mat-panel-title>
        </mat-expansion-panel-header>
        <!-- Content -->
        <ion-grid class="expandable__content ion-no-padding ion-padding-top">
            <ion-row class="ion-no-padding ion-margin-bottom ion-align-items-center"
                     *ngFor="let item of panel.items; let i = index;">
                <ion-col class="ion-no-padding ion-margin-end"
                         *ngIf="!item.inEditMode"
                         size="6">
                    <ion-label [ngClass]="{ 'expandable__label--custom': item.custom }"
                               (click)="editLabel(item)">
                        {{ item.label }}:
                    </ion-label>
                </ion-col>
                <ion-col class="ion-no-padding ion-margin-end"
                         *ngIf="item.inEditMode"
                         size="6">
                    <ion-input id="{{ item.label }}"
                               class="input--editable"
                               type="text"
                               name="{{ item.label }}"
                               aria-label="Input Value"
                               mode="ios"
                               inputmode="text"
                               [(ngModel)]="item.label"
                               (ionChange)="onInputChange()"
                               (ionBlur)="changeInEditMode(item)"></ion-input>
                </ion-col>
                <ion-col class="ion-no-padding">
                    <ion-grid class="ion-no-padding">
                        <ion-row class="ion-no-padding ion-align-items-center">
                            <ion-col class="ion-no-padding">
                                <ion-input class="ion-text-end"
                                           id="{{ item.value }}"
                                           type="text"
                                           name="{{ item.value }}"
                                           aria-label="Input Value"
                                           mode="ios"
                                           inputmode="text"
                                           [(ngModel)]="item.value"
                                           (ionChange)="onInputChange()"
                                           [disabled]="readonly"></ion-input>
                            </ion-col>
                            <ion-col class="ion-no-padding"
                                     *ngIf="item.value2 !== null"
                                     size="auto">
                                <ion-text>&nbsp;x&nbsp;</ion-text>
                            </ion-col>
                            <ion-col class="ion-no-padding" *ngIf="item.value2 !== null">
                                <ion-input class="ion-text-end"
                                           id="{{ item.value2 }}"
                                           type="text"
                                           name="{{ item.value2 }}"
                                           aria-label="Input Value"
                                           mode="ios"
                                           inputmode="text"
                                           [(ngModel)]="item.value2"
                                           (ionChange)="onInputChange()"
                                           [disabled]="readonly"></ion-input>
                            </ion-col>
                            <ion-col class="ion-no-padding"
                                     *ngIf="item.notes !== null && !isPublic && !item.inEditMode"
                                     size="auto">
                                &nbsp;
                                <ion-icon name="document"
                                          color="{{ item.notes === '' ? 'dark' : 'primary' }}"
                                          matTooltip="{{ item.notes !== '' ? item.notes : 'Add note' }}"
                                          [matTooltipPosition]="'after'"
                                          (click)="openAddNoteModal(i, item.notes)"></ion-icon>
                            </ion-col>
                            <ion-col class="ion-no-padding"
                                     *ngIf="item.inEditMode"
                                     size="auto">
                                &nbsp;
                                <ion-icon name="trash"
                                          matTooltip="Delete cost"
                                          [matTooltipPosition]="'after'"
                                          (click)="deleteCost(i)"></ion-icon>
                            </ion-col>
                        </ion-row>
                    </ion-grid>
                </ion-col>
            </ion-row>

            <!-- Add New -->
            <ion-row class="ion-no-padding ion-margin-bottom ion-align-items-center" *ngIf="!readonly">
                <ion-col class="ion-no-padding">
                    <div class="expandable__add-cost-row" (click)="addCost()">
                        <ion-icon name="add-circle" color="success"></ion-icon>
                        <ion-text color="success">Add Cost</ion-text>
                    </div>
                </ion-col>
            </ion-row>
        </ion-grid>

        <!-- Footer -->
        <ion-grid class="expandable__footer ion-no-padding">
            <ion-row class="ion-no-padding">
                <ion-col class="ion-no-padding">
                    <ion-label>Subtotal:</ion-label>
                </ion-col>
                <ion-col class="ion-no-padding" size="auto">
                    <ion-label>{{ subtotal | currency: 'USD': 'symbol' : '1.0-0' }}</ion-label>
                </ion-col>
            </ion-row>
        </ion-grid>
    </mat-expansion-panel>

    <ion-grid class="expandable-wrapper__subtotal expandable__footer ion-no-padding" *ngIf="!expanded">
        <ion-row class="ion-no-padding">
            <ion-col class="ion-no-padding">
                <ion-label>Subtotal:</ion-label>
            </ion-col>
            <ion-col class="ion-no-padding" size="auto">
                <ion-label>{{ subtotal | currency: 'USD': 'symbol' : '1.0-0' }}</ion-label>
            </ion-col>
        </ion-row>
    </ion-grid>
</div>
